export enum ERole {
  ASSISTANT = 'assistant',
  USER = 'user',
}

export enum EResponseType {
  TEXT = 'text',
  FILE = 'file',
  SELECT = 'select',
  ERROR = 'error',
}

export type TUploadFile = {
  name: string;
  type: string;
  id?: string;
};

export type TAction = {
  label: string;
  disabled?: boolean;
};

// ------------- Chat History -------------

type TBaseMessage = {
  id: string;
  content: string;
  role: ERole;
  timestamp: string;
  conversationId: string | null;
};

type TMessageOptions = {
  loading?: boolean;
  type?: EResponseType;
  file?: FileWithId[];
  url?: string[];
  actions?: TAction[];
  feedback?: {
    vote: EFeedback;
  };
  isFileResponse?: boolean;
  model?: string;
  knowledgeBase?: string[];
  allFiles?: FileWithId[];
};

export type FileWithId = {
  file: File;
  id: string;
  uploadedAt?: number;
  isS3Upload?: boolean;
  currentPath?: string;
  uuid?: string;
};

export type TMessage = TBaseMessage & Partial<TMessageOptions>;

export type TChatHistory = {
  primaryConversationId: string | null; // conversation id for general chat
  secondaryConversationId: string | null; // conversation id for chat with file
  messages: TMessage[];
  documentId?: string[] | null;
  runId?: string | null;
  intentId?: string | null;
  isLoading: boolean;
};

export type TGetChatResponsePayload = {
  question: string;
  conversationId?: string;
  documentId?: string[];
};


export type  TMessageWithFile = {
     value: string;
     files: FileWithId[];
}

// ------------- Feeback -------------
export type IFeebackPayload = {
  pipeline_type: string;
  message: string;
  sentiment: string;
  path: string;
};

export enum EFeedback {
  DISLIKE = 'DISLIKE',
}

export type FeedbackFormStatus = 'INITIAL' | 'CLICKED' | 'SUBMITTED' | 'DONE';
